class Store {

}

export default Store;
